import { LitElement, html, svg } from 'lit';

export class IconBed24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Seng</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M.75 8.25 12 1l11.223 7.232M2.25 18.75h19.5v4.5H2.25M2.25 18.75v-4.5h3a3 3 0 0 1 3 3v1.5M9 18.75l1.006-2.012a4.5 4.5 0 0 1 4.025-2.488h4.719a3 3 0 0 1 3 3v1.5M2.25 23.25v-10.5"></path></svg>`; }
}
if (!customElements.get('f-icon-bed24', IconBed24)) {
  customElements.define('f-icon-bed24', IconBed24);
}